export default __webpack_public_path__ + "static/media/signal_8.59404ebd.mp3";